// extracted by mini-css-extract-plugin
export default {"sessionDeleteOuterCard":"SessionDeletePopup_sessionDeleteOuterCard__5NkZM"};